<template>
  <div class="cardContent">
    <div class="table-box">
      <div class="tableTitle flex">
        <div style="width:30%">名称</div>
        <div style="width:40%">主要种植品种</div>
        <div style="width:30%">规模(面积)</div>
      </div>
      <div class="tableBody" ref="" @click.stop="handleSectionClick($event)">
        <vue-seamless-scroll
          :data="tableData"
          style="height:100%;"
          :class-option="classOption"
        >
          <ul>
            <li
              v-for="(item, index) in tableData"
              :key="index"
              class="flex content"
              :data-id="item.id"
            >
              <div style="width:30%;">{{ item.name }}</div>
              <div style="width:40%;">
                {{ item.main_plant }}
              </div>
              <div style="width:30%;">
                <span class="money-num">{{ item.area }}</span
                >亩
              </div>
            </li>
          </ul>
        </vue-seamless-scroll>
      </div>
    </div>
    <!-- <div class="chart" ref="circleChart"></div> -->
  </div>
</template>

<script>
import * as L from "leaflet";
import { get } from "@/api/index";
import { findIndexByName } from "@/util/index";
export default {
  components: {},
  computed: {
    classOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true // 开启数据实时监控刷新dom
      };
    }
  },
  props: {
    //是否滚动, 默认滚动
    isScrolled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tableData: []
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    handleSectionClick(e) {
      let target = e.target;
      if (target.tagName == "DIV") {
        if (target.parentNode.tagName == "LI") {
          this.showmapinfo(target.parentNode.dataset.id);
        }
      }
      if (target.tagName == "LI") {
        this.showmapinfo(target.dataset.id);
      }
    },
    showmapinfo(id) {
      //todo find data
      console.log("in showmapinfo", id);
      let index = findIndexByName(id, this.tableData, "id");
      if (index > -1) {
        const data = this.tableData[index];
        if (window.map) {
          console.log(
            window.map.latLngToContainerPoint(
              L.latLng([data.latitude, data.longitude])
            )
          );
          window.map.setView(L.latLng([data.latitude, data.longitude]), 1);
          setTimeout(() => {
            this.$bus.$emit(
              "updZzdhInfo",
              data.name,
              window.map.latLngToContainerPoint(
                L.latLng([data.latitude, data.longitude])
              )
            );
          }, 500);
        }
      }
    },
    // 获取表格数据
    getTableData() {
      get("/api/restful/findZzjdList").then(res => {
        this.tableData = res.data;
      });

      //   this.tableData = [
      //     {
      //       country: "信宜市",
      //       name: "妃子笑",
      //       unit: "万亩",
      //       sum: 2.3
      //     },
      //     {
      //       country: "信宜市",
      //       name: "桂味",
      //       sum: 0.8,
      //       unit: "万亩"
      //     },
      //     {
      //       country: "信宜市",
      //       sum: 4.4,
      //       unit: "万亩",
      //       name: "白糖罂"
      //     },
      //     {
      //       country: "信宜市",
      //       name: "白蜡",
      //       unit: "万亩",
      //       sum: 1.2
      //     },
      //     {
      //       country: "信宜市",
      //       sum: 2.6,
      //       name: "糯米糍",
      //       unit: "万亩"
      //     },
      //     {
      //       country: "信宜市",
      //       name: "进奉",
      //       unit: "万亩",
      //       sum: 10
      //     },
      //     {
      //       country: "信宜市",
      //       sum: 1.7,
      //       unit: "万亩",
      //       name: "黑叶"
      //     },
      //     {
      //       name: "妃子笑",
      //       country: "化州市",
      //       sum: 24.6,
      //       unit: "万亩"
      //     },
      //     {
      //       country: "化州市",
      //       sum: 0.8,
      //       unit: "万亩",
      //       name: "无核荔"
      //     },
      //     {
      //       name: "桂味",
      //       country: "化州市",
      //       unit: "万亩",
      //       sum: 6.2
      //     },
      //     {
      //       country: "化州市",
      //       unit: "万亩",
      //       sum: 4,
      //       name: "白糖罂"
      //     },
      //     {
      //       name: "白蜡",
      //       country: "化州市",
      //       sum: 3.2,
      //       unit: "万亩"
      //     },
      //     {
      //       name: "糯米糍",
      //       country: "化州市",
      //       sum: 5.76,
      //       unit: "万亩"
      //     },
      //     {
      //       sum: 2.2,
      //       name: "鸡嘴荔",
      //       country: "化州市",
      //       unit: "万亩"
      //     },
      //     {
      //       country: "化州市",
      //       unit: "万亩",
      //       sum: 3.6,
      //       name: "黑叶"
      //     },
      //     {
      //       sum: 13,
      //       country: "电白区",
      //       name: "妃子笑",
      //       unit: "万亩"
      //     },
      //     {
      //       country: "电白区",
      //       name: "桂味",
      //       unit: "万亩",
      //       sum: 5
      //     },
      //     {
      //       country: "电白区",
      //       unit: "万亩",
      //       sum: 11,
      //       name: "白糖罂"
      //     },
      //     {
      //       name: "白蜡",
      //       sum: 12,
      //       country: "电白区",
      //       unit: "万亩"
      //     },
      //     {
      //       country: "电白区",
      //       name: "糯米糍",
      //       sum: 0.96,
      //       unit: "万亩"
      //     },
      //     {
      //       country: "电白区",
      //       unit: "万亩",
      //       name: "黑叶",
      //       sum: 30.24
      //     },
      //     {
      //       country: "茂南区",
      //       sum: 0.42,
      //       name: "妃子笑",
      //       unit: "万亩"
      //     },
      //     {
      //       country: "茂南区",
      //       name: "桂味",
      //       unit: "万亩",
      //       sum: 1
      //     },
      //     {
      //       country: "茂南区",
      //       unit: "万亩",
      //       sum: 0.64,
      //       name: "白糖罂"
      //     },
      //     {
      //       country: "茂南区",
      //       name: "白蜡",
      //       unit: "万亩",
      //       sum: 0.9
      //     },
      //     {
      //       country: "茂南区",
      //       name: "糯米糍",
      //       sum: 0.24,
      //       unit: "万亩"
      //     },
      //     {
      //       country: "茂南区",
      //       unit: "万亩",
      //       sum: 1.8,
      //       name: "黑叶"
      //     },
      //     {
      //       name: "妃子笑",
      //       unit: "万亩",
      //       sum: 2.8,
      //       country: "高州市"
      //     },
      //     {
      //       name: "桂味",
      //       unit: "万亩",
      //       sum: 14.4,
      //       country: "高州市"
      //     },
      //     {
      //       unit: "万亩",
      //       country: "高州市",
      //       name: "白糖罂",
      //       sum: 11.6
      //     },
      //     {
      //       name: "白蜡",
      //       sum: 16.8,
      //       unit: "万亩",
      //       country: "高州市"
      //     },
      //     {
      //       name: "糯米糍",
      //       unit: "万亩",
      //       sum: 1,
      //       country: "高州市"
      //     },
      //     {
      //       sum: 2.2,
      //       name: "鸡嘴荔",
      //       unit: "万亩",
      //       country: "高州市"
      //     },
      //     {
      //       sum: 62.4,
      //       unit: "万亩",
      //       country: "高州市",
      //       name: "黑叶"
      //     }
      //   ];
    }
  }
};
</script>

<style lang="stylus" scoped>
.cardContent
  height 100%
.table-box
      width 460px
      margin 0 auto
      .tableTitle
        background transparent
        color #fff
        padding 8px 5px
        font-size 15px
        text-align center
        justify-content center

      .tableBody
        height calc(100% - 10px)
        overflow hidden
        font-size 13px

      .scroll-content
        position relative
        transition top .9s

      .content
        padding 0px 5px
        line-height 40px
        color #fff
        cursor pointer
        text-align center
        .money-num
          font-size 20px
          color #FCDC00
        .sale-num
          font-size 20px
          color #02c8f4

      .content:nth-child(2n+1)
        line-height 34px
        background #003c5e
        // border-radius 17px
</style>
